import { render, staticRenderFns } from "./group-label.vue?vue&type=template&id=6e0eb4fe"
import script from "./group-label.vue?vue&type=script&lang=js"
export * from "./group-label.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports